"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStackOrder = void 0;
var _web = require("@react-hookz/web");
var _react = require("react");
var _StackOrderContext = require("./StackOrderContext");
const useStackOrder = _ref => {
  let {
    isOpen,
    onCloseRequested,
    shouldCloseOnEscape = true
  } = _ref;
  // const [stackOrderSub, setStackOrderSub] = useState<StackOrderManagerSubscription | null>(null);
  const isMounted = (0, _web.useIsMounted)();

  // Null here means no stack order context provider is present.
  const [isActiveItem, setIsActiveItem] = (0, _react.useState)(null);
  const stackOrderContextValue = (0, _react.useContext)(_StackOrderContext.StackOrderContext);
  (0, _react.useEffect)(() => {
    if (isOpen && stackOrderContextValue) {
      const stackSubscription = stackOrderContextValue.stackOrderManager.addToStack({
        onStackChange: _ref2 => {
          let {
            isActiveItem
          } = _ref2;
          setIsActiveItem(isActiveItem);
        }
      });
      // setStackOrderSub(stackSubscription);
      setIsActiveItem(stackSubscription.isActiveItem());
      return () => {
        stackSubscription?.remove();
        if (isMounted()) {
          // setStackOrderSub(null);
        }
      };
    }
  }, [stackOrderContextValue, isOpen, isMounted]);
  (0, _react.useEffect)(() => {
    if (isOpen) {
      const handleKeyDown = event => {
        // bail if we are in a stack but aren't the active item.
        if (stackOrderContextValue && isActiveItem === false) {
          return;
        }
        if (event.key === "Esc" || event.key === "Escape") {
          // This line is necessary for Safari fullscreen mode, which overtakes
          // any Escape key press to exit fullscreen mode.  We want to have
          // control to first exist our active components, e.g. modals.
          event.preventDefault();
          if (shouldCloseOnEscape) {
            onCloseRequested();
          }
        }
      };
      document.addEventListener("keydown", handleKeyDown);
      return () => {
        document.removeEventListener("keydown", handleKeyDown);
      };
    }
  }, [isOpen, stackOrderContextValue, onCloseRequested, shouldCloseOnEscape, isActiveItem]);
  return {
    isActiveItem: !!isActiveItem,
    isWithinStack: !!stackOrderContextValue && isActiveItem !== null
  };
};
exports.useStackOrder = useStackOrder;
//# sourceMappingURL=useStackOrder.js.map